import httpRequest from '@/request'
const API = {
    REGION: '/front/energygov/v1/supervisionDicRegion/list/',//区域列表
    INDUSTRY: '/front/energygov/v1/supervisionDicIndustry/list',//行业列表
    COMPANY: '/front/energygov/v1/supervisionCollectEnterpriseInfo/list',//企业信息列表
    DECRYPTURL:'/front/energygov/v1/supervisionFile/decryptUrl',//obs文件解密
    TOOLMAINLIST:'/front/energygov/v1/supervisionMeasuringToolMain/list/',//获取计量器具配备信息列表
}
export function getRegionListRequest(params: any) {
    return httpRequest({
      url: API.REGION+params.regionCode,
      method: 'get',
    })
}
export function getIndustryListRequest(params: any) {
    return httpRequest({
      url: API.INDUSTRY,
      method: 'get',
      params
    })
}
export function getSupervisionCompanyListRequest(params: any) {
    return httpRequest({
      url: API.COMPANY,
      method: 'get',
      params
    })
}
export function getdDcryptUrlRequest(params:any){
    return httpRequest({
        url:API.DECRYPTURL,
        method:'get',
        params
    })
}
export function getToolMainListRequest(params:any){
    return httpRequest({
        url:API.TOOLMAINLIST+params.id,
        method:'get',
        params
    })
}